import { gql, useLazyQuery, useQuery } from '@apollo/client';
export const GET_ALL_BY_BUSINESS_UNIT = gql`
  query getAllByBusinessUnit($businessUnitId: Long) {
    tree_readAllByBusinessUnit(businessUnitId: $businessUnitId)
  }
`;
export const useGetAllByBusinessUnitLazyQuery = options => {
  return useLazyQuery(GET_ALL_BY_BUSINESS_UNIT, options);
};
export const useGetAllByBusinessUnitQuery = options => {
  return useQuery(GET_ALL_BY_BUSINESS_UNIT, options);
};